<template>
  <div id="app" class="map-root-ct" @click="appClick">
    <tutorial-modal />
    <measure-map
      ref="map"
      :enable-editing="meta.viewMode == 'edit'"
      @map-drag="handleMapDrag"
      @map-drag-end="handleMapDragEnd"
    ></measure-map>
    <status-panel
      v-if="meta.showStatusPanel"
      :show-measurement="meta.showMeasurements"
      :view-mode="meta.viewMode"
      v-on:add-shape-click="addMapShape">
    </status-panel>
    <control-panel
      v-if="meta.showControlPanel"
      :show-search-button="meta.showControlPanelSearchButton"
      v-on:add-shape-click="addMapShape">
    </control-panel>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { useGTag } from '@/composables/useGTag'

import StatusPanel from './components/StatusPanel.vue'
import MeasureMap from './components/MeasureMap.vue'
import ControlPanel from './components/ControlPanel.vue'
import TutorialModal from './components/TutorialModal.vue'

export default {
  components: {
    StatusPanel,
    MeasureMap,
    ControlPanel,
    TutorialModal
  },
  emits: ['map-init'],
  setup(props, { emit }) {
    const route = useRoute()
    const mainStore = useMainStore()
    const { gTagEvent } = useGTag()

    const map = ref(null)

    const meta = computed(() => route.meta)

    const appClick = () => {
      mainStore.setAppClicked()
    }

    const addMapShape = (shapeCfg) => {
      if (shapeCfg.shape == 'free') {
        mainStore.setMode('free')
        mainStore.setToolType(shapeCfg.type)
        return
      }

      mainStore.addShape(shapeCfg)
    }

    const handleMapDrag = () => {
      mainStore.setMapDrag(true)
    }

    const handleMapDragEnd = () => {
      mainStore.setMapDrag(false)
    }

    onMounted(() => {
      emit('map-init')
    })

    return {
      map,
      meta,
      appClick,
      addMapShape,
      handleMapDrag,
      handleMapDragEnd,
      gTagEvent
    }
  }
}
</script>
